/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank5Outline = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z" />
        <path d="M9.585 15.2v-1.33a4.584 4.584 0 0 0 2.04.47c.427 0 .763-.1 1.01-.3.247-.2.37-.473.37-.82 0-.333-.103-.593-.31-.78-.2-.187-.487-.28-.86-.28-.433 0-.877.1-1.33.3l-.88-.69.42-3.42h3.95v1.27h-2.83l-.18 1.56c.34-.12.687-.18 1.04-.18.74 0 1.323.2 1.75.6.427.393.64.937.64 1.63 0 .487-.11.913-.33 1.28-.22.36-.533.64-.94.84-.4.2-.87.3-1.41.3-.413 0-.81-.04-1.19-.12a3.762 3.762 0 0 1-.96-.33z" />
      </g>
    </g>
  </Icon>
);
export { SvgRank5Outline as Rank5Outline };
